'use strict';
import ActionType from 'constants/actionType';
import Dispatcher from 'dispatcher/appDispatcher';
import menuApi from 'api/menuApi';
import moduleCodes from 'constants/moduleCodes';
import * as AppAction from '../../../../action/appAction';
import { organisationSettingsActions } from '../../../../action/organisationSettingsAction';
import '../../../../store/organisationSettingsStore';

const MODULE_CODE = moduleCodes.MODULE_2BAP;

const Actions = {
  async getMenu() {
    const menu = await menuApi.getMenu(MODULE_CODE);

    Dispatcher.dispatch({
      actionType: ActionType.MENU_INITIALIZE,
      initialData: {
        menu,
        module: MODULE_CODE
      }
    });
  },

  async init2BapApp() {
    AppAction.setModuleState(false);
    await Promise.all([
      organisationSettingsActions.getOrganisationSettings(),
      Actions.getMenu()
    ]);
    AppAction.setModuleState(true);
  }
};

export default Actions;
